/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetPaymentReceiptDetailsRequest} from '@cash-web/protos/squareup/cash/cashbusinesspayments/api/v1beta1/receipt_data.pb'
import {GetPaymentReceiptDetailsResponse} from '@cash-web/protos/squareup/cash/cashbusinesspayments/api/v1beta1/receipt_data.pb'


export const getPaymentReceiptDetails = (request: GetPaymentReceiptDetailsRequest, options?: CashRequestOptions) => post<GetPaymentReceiptDetailsRequest, GetPaymentReceiptDetailsResponse>("/cash-app/business-payments/get-receipt-details", request, {...options, rejectOnError: true })